// extracted by mini-css-extract-plugin
export default {"Card":"FileItem_Card__p2YuL","CardActions":"FileItem_CardActions__iEp7E"};